// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__K9xtK","contact":"Footer_contact__Iv4XI"};